import MovableItemActionResult from 'app/src/engine/action-results/MovableItemActionResult';

export default class HaltActionResult extends MovableItemActionResult {}
